<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="CN ParaOverride-7" id="_idParaDest-7"><span class="CharOverride-1"><a id="_idTextAnchor001"></a></span><a href="#/97808021495415#_idTextAnchor000"><span class="CharOverride-1">Prologue</span></a></p>
<p class="Q_F ParaOverride-8"><span class="CharOverride-11">Love at first sight is a hypnosis.</span></p>
<p class="Q_F ParaOverride-9"><span class="CharOverride-8">—Roland Barthes</span></p>
<p class="Epi_F ParaOverride-10"><span class="I _idGenCharOverride-1">–</span> <span class="I _idGenCharOverride-1">I don’t believe in love at first sight.</span></p>
<p class="Epi_L">– What do you mean? Wasn’t it clear the moment you picked the elderflowers by the park and we looked at each other? Or was it in that book club?</p>
<p class="TX_Break">A few years after we moved in together, we had this conversation about love at first sight. I remember you said:</p>
<p class="TX">‘I don’t believe in love at first sight.’</p>
<p class="TX">I was taken aback. I thought we were definitely in love at first sight.</p>
<p class="TX">‘What do you mean? Wasn’t it clear the moment you picked the elderflowers by the park and we looked at each other? Or was it in that book club?’</p>
<p class="TX">You gave me a damp smile, as if my confusion proved that you were right.</p>
<p class="TX">But doesn’t love always start from first sight? I mean, before one reaches one’s thirties or forties. It’s only when we have a second thought about our first sighted love, that we might change our mind. You might ask, why does this happen before one reaches midlife? I don’t have a theory yet, but I think when we are young, our impulses take over our mind. Romantic love is always an impulse in my case. I am not old or wise enough to understand yet what else love could be.</p>
<p class="TX">All I knew in that first moment at the park was that you saw the way I had looked at you. Perhaps I should not be so sure that you saw how I looked at you. Well, you were still a complete stranger. You were from a culture I had no know­ledge or deep understanding of. Besides, you were very tall and I was short. Height sometimes disorients our perspective.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 97808021495416.vue?ddcb2390